module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "xinghao"
    }
  }, [_c('div', {
    staticClass: "brand container"
  }, [_c('h4', [_vm._v("品牌")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.brandLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "brandListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectBrand(item, index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.brandName) + "\n                "), _c('span', {
      class: {
        active: _vm.activeIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), (_vm.basicsAuth.exitBrand) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitBrand(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.deleBrand) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleBrand(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.basicsAuth.newBrand) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newBrand()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textMenu[_vm.dialogMenuStatus],
      "visible": _vm.dislogBrand,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogBrand = $event
      },
      "close": function($event) {
        return _vm.emptyDialog('brandForm')
      }
    }
  }, [_c('el-form', {
    ref: "brandForm",
    attrs: {
      "model": _vm.brandForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.brandFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品牌名称：",
      "prop": "brandName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "12",
      "placeholder": "不超过12个字"
    },
    model: {
      value: (_vm.brandForm.brandName),
      callback: function($$v) {
        _vm.$set(_vm.brandForm, "brandName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "brandForm.brandName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.brandForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.brandForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "brandForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "initiateMode"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.brandForm.initiateMode),
      callback: function($$v) {
        _vm.$set(_vm.brandForm, "initiateMode", $$v)
      },
      expression: "brandForm.initiateMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上线状态：",
      "prop": "onlineStatus"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.brandForm.onlineStatus),
      callback: function($$v) {
        _vm.$set(_vm.brandForm, "onlineStatus", $$v)
      },
      expression: "brandForm.onlineStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogMenuStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addEventFormSubmitBtn('brandForm')
      }
    }
  }, [_vm._v("添加 ")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveEventFormSubmitBtn('brandForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyDialog('brandForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "category container"
  }, [_c('h4', [_vm._v("品类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.categoryLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "categoryListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectCategory(item, index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.categoryName) + "\n                "), _c('span', {
      class: {
        active: _vm.activeCategoryIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), (_vm.basicsAuth.exitCategory) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitCategory(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.deleCategory) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleCategory(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.basicsAuth.newCategory) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newCategory()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textCategoryMenu[_vm.dialogCategoryStatus],
      "visible": _vm.dislogCategory,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogCategory = $event
      },
      "close": function($event) {
        return _vm.emptyCategoryDialog('categoryForm')
      }
    }
  }, [_c('el-form', {
    ref: "categoryForm",
    attrs: {
      "model": _vm.categoryForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.categoryFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品类名称：",
      "prop": "categoryName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "12",
      "placeholder": "不超过12个字"
    },
    model: {
      value: (_vm.categoryForm.categoryName),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "categoryName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "categoryForm.categoryName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.categoryForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "categoryForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "initiateMode"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.categoryForm.initiateMode),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "initiateMode", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "categoryForm.initiateMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上线状态：",
      "prop": "onlineStatus"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.categoryForm.onlineStatus),
      callback: function($$v) {
        _vm.$set(_vm.categoryForm, "onlineStatus", $$v)
      },
      expression: "categoryForm.onlineStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogCategoryStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addCategoryFormSubmitBtn('categoryForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveCategoryFormSubmitBtn('categoryForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyCategoryDialog('categoryForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Model container"
  }, [_c('h4', [_vm._v("型号")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.modelLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "modelListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectModel(item, index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.modelName) + "\n                "), _c('span', {
      class: {
        active: _vm.activeModelIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), (_vm.basicsAuth.exitModel) ? _c('span', {
      staticClass: "exitBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.exitModel(item)
        }
      }
    }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), (_vm.basicsAuth.deleModel) ? _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleModel(item)
        }
      }
    }) : _vm._e()])
  }), _vm._v(" "), (_vm.basicsAuth.newModel) ? _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newModel()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textModelMenu[_vm.dialogModelStatus],
      "visible": _vm.dislogModel,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogModel = $event
      },
      "close": function($event) {
        return _vm.emptyModelDialog('modelForm')
      }
    }
  }, [_c('el-form', {
    ref: "modelForm",
    attrs: {
      "model": _vm.modelForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.modelFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "型号名称：",
      "prop": "modelName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "maxlength": "25",
      "placeholder": "请输入型号名称（不超过20个字）"
    },
    model: {
      value: (_vm.modelForm.modelName),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "modelName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.modelName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.modelForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "modelForm.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择颜色："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "multiple": "",
      "placeholder": "请选择颜色"
    },
    model: {
      value: (_vm.colorChecklist),
      callback: function($$v) {
        _vm.colorChecklist = $$v
      },
      expression: "colorChecklist"
    }
  }, _vm._l((_vm.ColorLists), function(item) {
    return _c('el-option', {
      key: item.colorId,
      attrs: {
        "label": item.colorName,
        "value": item.colorId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "data": _vm.postData,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "accept": _vm.acceptImage,
      "on-success": _vm.handleModelAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过5Mb")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "启用状态：",
      "prop": "initiateMode"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.modelForm.initiateMode),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "initiateMode", $$v)
      },
      expression: "modelForm.initiateMode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上线状态：",
      "prop": "onlineStatus"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-value": 1,
      "inactive-value": -1
    },
    model: {
      value: (_vm.modelForm.onlineStatus),
      callback: function($$v) {
        _vm.$set(_vm.modelForm, "onlineStatus", $$v)
      },
      expression: "modelForm.onlineStatus"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogModelStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addModelFormSubmitBtn('modelForm')
      }
    }
  }, [_vm._v("添加")]) : _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveModelFormSubmitBtn('modelForm')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyModelDialog('modelForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "Fault container"
  }, [_c('h4', [_vm._v("故障大类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.faultLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultListPart listPart",
      on: {
        "click": function($event) {
          return _vm.selectFault(item, index)
        }
      }
    }, [_vm._v("\n                " + _vm._s(item.faultTypesName) + "\n                "), _c('span', {
      class: {
        active: _vm.activeFaultIndex === index
      }
    }, [_c('i', {
      staticClass: "el-icon-check"
    })]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleFault(item)
        }
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newFault()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textFaultMenu[_vm.dialogFaultStatus],
      "visible": _vm.dislogFault,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogFault = $event
      },
      "close": function($event) {
        return _vm.emptyFaultDialog('faultForm')
      }
    }
  }, [_c('el-form', {
    ref: "faultForm",
    attrs: {
      "model": _vm.faultForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.faultFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "故障大类：",
      "prop": "faultTypesName"
    }
  }, [(_vm.dialogFaultStatus !== 'update') ? _c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySearchAsync,
      "placeholder": "不超过12个字"
    },
    on: {
      "input": _vm.getPicking,
      "select": _vm.handleSelect
    },
    model: {
      value: (_vm.faultForm.faultTypesName),
      callback: function($$v) {
        _vm.$set(_vm.faultForm, "faultTypesName", $$v)
      },
      expression: "faultForm.faultTypesName"
    }
  }) : _c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.faultForm.faultTypesName),
      callback: function($$v) {
        _vm.$set(_vm.faultForm, "faultTypesName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "faultForm.faultTypesName"
    }
  })], 1), _vm._v(" "), (_vm.isAdd) ? _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.faultForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.faultForm, "sort", $$v)
      },
      expression: "faultForm.sort"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAdd) ? _c('el-form-item', {
    attrs: {
      "label": "故障描述"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.faultForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.faultForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "faultForm.memo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAdd) ? _c('el-form-item', {
    staticClass: "clearfix",
    attrs: {
      "label": "展示图片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "accept": _vm.acceptImage,
      "on-success": _vm.handleFaultAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageFaultUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageFaultUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过5Mb")])]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader fl",
    attrs: {
      "data": _vm.postData,
      "accept": _vm.acceptImage,
      "action": "https://upload.qiniup.com",
      "show-file-list": false,
      "on-success": _vm.handlePictureCardPreview2,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.dialogImageSrc) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.dialogImageSrc
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogFaultStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addFaultFormSubmitBtn('faultForm')
      }
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyFaultDialog('faultForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "faultSub container"
  }, [_c('h4', [_vm._v("故障小类")]), _vm._v(" "), _c('ul', {
    staticClass: "clearfix"
  }, [_vm._l((_vm.faultSubLists), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "faultListPart listPart"
    }, [_vm._v("\n                " + _vm._s(item.faultSubclassName) + "\n                "), _c('i', {
      staticClass: "el-icon-error activeDelBtn",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.deleFaultSub(item)
        }
      }
    })])
  }), _vm._v(" "), _c('li', {
    staticClass: "addContent",
    on: {
      "click": function($event) {
        return _vm.newFaultSubClass()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })])], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.textFaultSubMenu[_vm.dialogFaultSubStatus],
      "visible": _vm.dislogFaultSub,
      "close-on-click-modal": false,
      "width": "600px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dislogFaultSub = $event
      },
      "close": function($event) {
        return _vm.emptyFaultSubDialog('faultSubForm')
      }
    }
  }, [_c('el-form', {
    ref: "faultSubForm",
    attrs: {
      "model": _vm.faultSubForm,
      "label-width": "100px",
      "label-position": _vm.labelPosition,
      "rules": _vm.faultSubFormRules
    }
  }, [(_vm.isAddSub) ? _c('el-form-item', {
    attrs: {
      "label": "小类简称：",
      "prop": "faultSubclassShortName"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.faultSubForm.faultSubclassShortName),
      callback: function($$v) {
        _vm.$set(_vm.faultSubForm, "faultSubclassShortName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "faultSubForm.faultSubclassShortName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "故障小类：",
      "prop": "faultSubclassName"
    }
  }, [(_vm.dialogFaultSubStatus !== 'update') ? _c('el-autocomplete', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "fetch-suggestions": _vm.querySubSearchAsync,
      "placeholder": "请输入故障小类名称（不超过32个字）"
    },
    on: {
      "input": _vm.getSubPicking,
      "select": _vm.handleSubSelect
    },
    model: {
      value: (_vm.faultSubForm.faultSubclassName),
      callback: function($$v) {
        _vm.$set(_vm.faultSubForm, "faultSubclassName", $$v)
      },
      expression: "faultSubForm.faultSubclassName"
    }
  }) : _c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.faultSubForm.faultSubclassName),
      callback: function($$v) {
        _vm.$set(_vm.faultSubForm, "faultSubclassName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "faultSubForm.faultSubclassName"
    }
  })], 1), _vm._v(" "), (_vm.isAddSub) ? _c('el-form-item', {
    attrs: {
      "label": "排序：",
      "prop": "sort"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.faultSubForm.sort),
      callback: function($$v) {
        _vm.$set(_vm.faultSubForm, "sort", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "faultSubForm.sort"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAddSub) ? _c('el-form-item', {
    attrs: {
      "label": "故障描述"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.faultSubForm.memo),
      callback: function($$v) {
        _vm.$set(_vm.faultSubForm, "memo", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "faultSubForm.memo"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isAddSub) ? _c('el-form-item', {
    attrs: {
      "label": "展示图片："
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "data": _vm.postData,
      "action": "https://up.qiniup.com",
      "show-file-list": false,
      "accept": _vm.acceptImage,
      "on-success": _vm.handleFaultSubAvatarSuccess,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.imageFaultSubUrl) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.imageFaultSubUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过5Mb")])])], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.dialogFaultSubStatus !== 'update') ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.addFaultSubFormSubmitBtn('faultSubForm')
      }
    }
  }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.emptyFaultSubDialog('faultSubForm')
      }
    }
  }, [_vm._v("取 消")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-16bbf733","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/basicsConfigure.vue
// module id = 1598
// module chunks = 0